var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask text-left",
        attrs: { tabindex: "0" },
        on: {
          keyup: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
            ) {
              return null
            }
            _vm.$emit("close")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.$emit("close")
              }
            }
          },
          [
            _c("div", { staticClass: "modal-container container" }, [
              _c("div", { staticClass: "container flex flex-wrap mx-auto" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-exit w-full",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "line" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "line2" })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2)
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }